import { Module } from 'vuex';
import { IRootState } from '@/store';
import { IInventoryAdvancePaymentData, IUserData } from '@/models';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { IInventoryAdvancePaymentState } from './inventoryadvancepayment.types';

export const state: IInventoryAdvancePaymentState = {
  version: 1,
  inventoryAdvancePayments: [] as IInventoryAdvancePaymentData[],
  count: 0,
  approvers: [] as IUserData[],
  apSpecialists: [] as IUserData[],
  currentAssignees: [] as IUserData[],
  financeManagers: [] as IUserData[],
  activities: [],
  comments: [],
  lastCreatedInventoryAdvancePaymentCommentId: null,
  mentionableUsers: [],
  lastPromise: null
};

const namespaced = true;

export const inventoryAdvancePayment: Module<
  IInventoryAdvancePaymentState,
  IRootState
> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
